import * as React from "react";
import { useEffect, useRef, useState } from "react";
import type { ComponentProps } from "widgets/BaseComponent";
import { Button, Cascader, Col, Divider, Row, Tag } from "antd";
import { LabelPosition } from "../../../components/constants";
import _ from "lodash";
import styled from "styled-components";
import { LABEL_CONTAINER_CLASS, LabelWithTooltip, labelLayoutStyles } from "@design-system/widgets-old";
import MapWidget from "@byk/pages/components/MapWidget";
import { CloseCircleOutlined, EnvironmentFilled } from "antdIcons";
import { strToJson, uuid2 } from "@byk/utils/Utils";
import {lightenColor} from "../../../widgets/WidgetUtils";


const ContainerWrapper = styled.div<any>`
  ${labelLayoutStyles}
  & .${LABEL_CONTAINER_CLASS} {
    align-self: center;
    ${({ labelPosition }) =>
    labelPosition === LabelPosition.Left && "min-height: 32px"};
  }

  .ant-btn {
    height: auto !important;
    background: ${({ btn_bgColor}) => btn_bgColor || 'white'}!important;
    color: ${({btn_color}) => btn_color}!important;
    font-size: ${({btn_fontSize}) => {
      return (btn_fontSize ? `${btn_fontSize}` : "14px") + ' !important;'
    }};
    border-radius: ${({ borderRadius }) => `${borderRadius}`} !important;
    box-shadow: ${({ boxShadow }) => `${boxShadow}`} !important;
    border-width: ${({ borderWidth }) => `${borderWidth}px`};
    margin-bottom:${({ borderWidth }) => `${borderWidth}px`};
    border-color: ${({ btn_borderColor }) => btn_borderColor} !important;
  }

   .ant-btn:hover, .ant-btn:active, .ant-btn:focus {
      border-width: ${({ borderWidth }) => `${borderWidth || 1}px !important`};
      border-color: ${({btn_borderColor, accentColor}) => (btn_borderColor || accentColor)}!important;
      background: ${({ btn_bgColor}) => lightenColor(btn_bgColor || 'white')}!important;
      color: ${({btn_color, accentColor}) => (btn_color || accentColor)}!important;
   }

  .ant-tag {
    line-height: normal !important;
    display:inline !important;
    border-color: ${({ addr_borderColor }) => addr_borderColor} !important;
    border-width: ${({ addr_borderWidth }) => addr_borderWidth}px !important;
    background: ${({ addr_bgColor}) => {
      return (addr_bgColor ? `${addr_bgColor}` : "rgb(255, 255, 255)") + " !important;"
    }};
    color: ${({addr_color}) => {
      return (addr_color ? `${addr_color}` : "var(--wds-color-text)") + ' !important;'
    }};
    font-size: ${({addr_fontSize}) => {
      return (addr_fontSize ? `${addr_fontSize}` : "14px") + ' !important;'
    }};
  }
`;

const AmapWidget = (props: any) => {
  const {
    label,
    labelPosition,
    value,
    defaultValue,
    isDirty,
    updateWidgetProperty,
    onChange,
    onOpen,
    isReadonly,
    isDisabled,
    isRequired,
    labelWidth,
    selectedCount,
    labelTextColor,
    labelTextSize,
    labelStyle,
    btnText,
    securityJsKey,
    securityJsCode,
    sKey,
    accentColor,
    labelAlignment,
    compactMode,
    labelTooltip
  } = props;

  const chooseMapRef = useRef(null);
  const [isAction, setIsAction] = useState<any>(false);
  const [key, setKey] = useState<any>(uuid2());
  const showModel = () => {
    let _data = getValue(value, defaultValue);
    console.log("_data", _data);
    chooseMapRef.current?.showModal(_data);
  }
  const setValue = (v: any) => {
    let str_v = "";
    if (!_.isEmpty(v)) {
      str_v = JSON.stringify(v);
    }
    setKey(uuid2());
    setIsAction(true);
    updateWidgetProperty(str_v);
    onChange && onChange();
  }

  const getValue = (value: any) => {
    if (!isDirty && defaultValue) {
      return strToJson(defaultValue);
    } else {
      if(value){
        return strToJson(value);
      }
      else{
        return "";
      }
    }
  }

  return (
    <>
     <ContainerWrapper {...props}  compactMode={compactMode}
        data-testid="radiogroup-container"
        labelPosition={labelPosition}  key={key}>
     {label && (
          <LabelWithTooltip
            className={`datepicker-label`}
            text={label}
            cyHelpTextClassName="datepicker-tooltip"
            alignment={labelAlignment}
            color={labelTextColor}
            compact={compactMode}
            disabled={isDisabled}
            fontSize={labelTextSize}
            fontStyle={labelStyle}
            helpText={labelTooltip}
            position={labelPosition}
            width={labelWidth}
          />

        )}
          <>
            <div style={{width:"100%"}}>
            {!isReadonly && <Button icon={<EnvironmentFilled />} onClick={showModel}>{btnText}</Button>}
                  {
                    getValue(value) &&
                    <>
                      <Tag closeIcon={<CloseCircleOutlined />} color="#EEEEEE" style={{marginTop: isReadonly ? "0px" : "5px" }} closable={!isReadonly} onClose={() => setValue("")}>
                        {getValue(value)?.address}
                      </Tag>
                    </>
                  }
            </div>
          </>

              <MapWidget ref={chooseMapRef}
                securityJsKey={securityJsKey}
                securityJsCode={securityJsCode}
                zoomLevel={17} isShowCard={true} dragEnable={true} zoomEnable={true} isSearch={true}
                callback={setValue} mode="modal" defaultLngLat={getValue(value)}></MapWidget>
      </ContainerWrapper>
    </>
  )
};

class AmapComponent extends React.Component<AmapComponentProps> {
  constructor(props: AmapComponentProps) {
    super(props);
  }

  render() {
    return <AmapWidget {...this.props} />;
  }
}

export interface AmapComponentProps extends ComponentProps {
  updateWidgetProperty: any,
  onChange?: () => void,
  labelWidth?:any
  //key:any
}

export default AmapComponent;
